
import { ReportRow } from '@/store/admin';
import { dispatchReenterRequestReport } from '@/store/admin/actions';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ReenterRequestDiaglog extends Vue {
  public dialog = false;
  public request = '';
  @Prop({ default: null })
  public item!: ReportRow | null;

  get isLatestReport() {
    if (this.item) {
      let report_id = 0;
      for (let report of this.item.reports) {
        report_id = (report.id > report_id) ? report.id : report_id;
      }
      return report_id == this.item.report_id;
    } else {
      return false;
    }
  }

  public async reenterReport(item) {
    await dispatchReenterRequestReport(this.$store, { report_id: item.report_id, request: this.request });
    this.dialog = false;
    this.$emit('reload');
  }
}
